import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router';
import { launcherRoutes } from './launcher/routes';

/** Members never load the builder; it is a separate chunk fetched on the first /builder visit. */
const BuilderRoutes = lazy(() => import('./builder/routes'));

/**
 * Router shell. Owned by nobody after the scaffold: the launcher agent edits
 * src/launcher/**, the builder agent edits src/builder/**. Add routes there.
 */
export function App() {
  return (
    <Routes>
      {launcherRoutes}
      <Route
        path="/builder/*"
        element={
          <Suspense fallback={null}>
            <BuilderRoutes />
          </Suspense>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

function NotFound() {
  return (
    <main className="page">
      <h1>Not found</h1>
      <p>
        <a href="/">Back to your circles</a>
      </p>
    </main>
  );
}
